import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header'
import SEO from "../BaseComponents/SEO";
import useSeo from "../BaseComponents/SEO";

import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL } from '../../networkCalls';

const FAQs = () => {
    const toTop = () => {
        window.scrollTo(0, 0);
      }
      useEffect(() => {
        toTop();
      }, []);
    
    
      const seo = useSeo();
      const url = window.location.href;
      // console.log({url});
      const testurl =
      `${process.env.REACT_APP_PRO_MODE.replace(/\/$/, "")}${window.location.pathname}`;


    return (
      
      <>
        <SEO
       url={testurl}
      />
            {/* <Helmet>
                <title>FAQs</title>
                <meta name="description" content="FAQs" />
            </Helmet> */}
            <Header />
            <div className='innerpagebg pt-5 pb-5'>
                <div className='container mb-4'>
                    <div className='row'>
                        <div className='col-12  m-auto'>
                            <div className="align-items-center text-center">
                                <h1 className='h1_heading d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>FAQ<span  className='txtdgray f16'>s</span></span>
                                </h1>
                             </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row mb-4'>
                        <div className='col-lg-11 col-mg-12 col-sm-12 col-12 text-start m-auto card pt-4'>
                          <ol>
                            <li>
                                <p className='fw-bold mb-0'>How do I place an order?</p>
                                <p className='mb-1'>Shopping at www.hondaindiapower.com is easy and secure. Placing an online order requires just a few steps:</p>
                                <ul className='ms-0 ps-3'>
                                    <li>Select an item you would like to purchase, and then click the Buy Now button</li>
                                    <li>You are required to input the delivery pin code to check the nearby dealer. Select the Dealer as per your choice or stock availability.</li>
                                    <li>You can then choose to continue shopping which would allow you to browse and add more products along with your Dealer selection or can go directly to checkout.</li>
                                    <li>If you choose to continue shopping, when you have finished browsing and adding products to your Shopping Cart, please click on the Shopping Cart at the top right corner of page and follow the Checkout steps.</li>
                                    <li>If you are new to the website, you are required to create an account.</li>
                                    <li>During the Checkout process, you will be asked for the delivery address and payment details. At present we are only accepting prepaid orders.</li>
                                    <li>An email will be sent to your email address containing confirmation of receipt of your order and an order number.</li>
                                </ul>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>What should I do if I’m having trouble in placing an order?</p>
                                <p className='mb-1'>If you are facing any technical difficulties with the website, please call us toll-free at  1800-11-2323 or contact us via mail on customer.support@hipp.co.in</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>How do I cancel an order?</p>
                                <p className='mb-1'>you can easily cancel your order anytime until the invoice has been generated</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>How do I pay for my order?</p>
                                <p className='mb-1'>We only accept online payments made at the time of placing your order. You can pay for your orders via all Major Debit and Credit Cards, Net Banking, Paytm, or other available payment modes. Your payment information is encrypted and stored safely and securely by the Payment Gateway provider.</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>Do you offer Cash on Delivery?</p>
                                <p className='mb-1'>No, we currently do not offer Cash on Delivery for payment of your orders. You can pay for your orders using any supported online payment method during the checkout process.</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>Does Honda India Power Products Limited store my Credit / Debit card information or my Net banking account information?</p>
                                <p className='mb-1'>No, Honda India Power Products Limited does not collect or store your credit / debit card information or your net banking account information. When you choose to an online payment option, you will re-directed to our payment gateway partner Paytm for processing your payment. Your card / account information is securely processed by Paytm and the corresponding banks, without any sensitive information passing back to us. We only receive limited information that is necessary to verify whether the payment for your order was successful.</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>My payment has failed. What can I do?</p>
                                <p className='mb-1'>Your payment transaction may fail for reasons such as submission of incorrect payment details or exceeding your transaction limit. Most failures are recorded based responses sent by your bank. Since the payment is managed by your bank and a payment gateway partner, we receive only limited information regarding the payment failure.</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>My payment has failed. What can I do?</p>
                                <p className='mb-1'>Your payment transaction may fail for reasons such as submission of incorrect payment details or exceeding your transaction limit. Most failures are recorded based responses sent by your bank. Since the payment is managed by your bank and a payment gateway partner, we receive only limited information regarding the payment failure.</p>
                                <p className='mb-1'>If you have been charged for your failed transaction, please wait at least 72 hours for an automatic refund or contact your bank</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>Does Honda India Power Products provide Annual Maintenance Contract (AMC) and extended warranty on its products?</p>
                                <p className='mb-1'>Yes, Honda India Power Products Limited provides AMC on its products. Extended warranty is only applicable to Generators up to 2 years. For more information, please contact our customer care 1800-11-2323.</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>How can I contact the customer care?</p>
                                <p className='mb-1'>You can contact our customer care by calling on 1800-11-2323 or contact us via mail on customer.support@hipp.co.in. Our customer care is only available from Monday to Friday between the hours of 9 AM and 6 PM. Customer care is not available on weekends and public holidays.</p>
                            </li>
                            <li className='mt-4'>
                                <p className='fw-bold mb-0'>How do I return or replace a product?</p>
                                <p className='mb-1'>Currently, we do not accept return or replacement of the product. If the product is found defective by reasons of defective material or poor workmanship, products under warranty will be repaired or replaced of its defective part(s), at any authorized dealer, free of charge. In the event of failure, any Honda authorized dealer will repair or replace, free of cost, any part of the set, as per the norms laid down by the company. The company’s decision shall be final and binding.</p>
                            </li>
                          </ol>
                        </div>
                    </div>
                </div>
            </div>
            <FotterMain />
        </>
    )
}

export default FAQs